import type {CreateRepresentativeFormPayload} from "./create-representative.schema";
import type {CreateRepresentativeRequest} from "@project/sdk/sales";

export const createRepresentativeMapper = {
  toSdk: (payload: CreateRepresentativeFormPayload): CreateRepresentativeRequest => ({
    company: {
      companyId: payload.companyId,
      companyName: payload.companyName,
      partyProfile: {
        address: {address: payload.address},
        country: payload.country,
        phone: {
          regionCode: payload.phonePrefix,
          nationalNumber: payload.phoneNumber,
        },
        websiteUrl: payload.websiteUrl,
      },
    },
    logoUrl: payload.logoUrl,
    exclusive: payload.exclusive,
    contract: {
      contractedAt: payload.contractedAt,
      durationMonths: payload.durationMonths,
    },
  }),
};
